import { render, staticRenderFns } from "./list.vue?vue&type=template&id=08a1595a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=08a1595a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1595a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a1595a')) {
      api.createRecord('08a1595a', component.options)
    } else {
      api.reload('08a1595a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=08a1595a&scoped=true", function () {
      api.rerender('08a1595a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/taxPaymentReceipt/list.vue"
export default component.exports